import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

export enum TimerUpdateSource {
    APP_JS_BRIDGE = "app_js_bridge",
    UPDATE_CART = "checkout_update_cart",
    FETCH_COUPONS = "pl_fetch_coupons",
    EVENT_STATUS_POLLING = "event_status_polling",
}

export enum SwiggySixesCommState {
    DISABLED = "DISABLED",
    SIX_HIT = "SIX_HIT",
    CONSECUTIVE_SIXES_HIT = "CONSECUTIVE_SIXES_HIT",
    EXPIRED = "EXPIRED",
}

export interface SwiggySixesCroutonAPIInfo {
    offerExpiresInSec: string | number;
    icon: string;
    states: {
        [key in SwiggySixesCommState]: string[];
    };
}

export interface CouponTimer {
    text: string;
    endTimeEpochInSec: string | number;
    backgroundColor: string;
    textColor: keyof IColors;
}

export interface SwiggySixesTickerTimer {
    enabled: boolean;
    minutes?: number;
    seconds?: number;
}

export interface SwiggySixesCroutonComms {
    enabled: boolean;
    croutonState?: SwiggySixesCommState;
    croutonComms?: string[];
    icon?: string;
}
